export default class Gnav {
  constructor() {
    this.CL_OPEN = "isOpen";
    this.isOpen = false;
    this.target = document.querySelector('.gl_common_nav');

    const btnOpen = document.querySelector(".js-g_nav_open");
    btnOpen.addEventListener("click",()=>{
      this.onOpen();
    });
    document.querySelector(".js-g_nav_close").addEventListener("click",()=>{
      this.onClose();
    });

    document.addEventListener('click',(event)=>{
      if(!this.isOpen) return;
      if (!this.target.contains(event.target) && !btnOpen.contains(event.target)) {
        this.onClose();
      }
    });
  }

  onOpen(){
    this.isOpen = true;
    this.target.classList.add(this.CL_OPEN);
  }

  onClose(){
    this.isOpen = false;
    this.target.classList.remove(this.CL_OPEN);
  }
}
